import { useState } from 'react';

export function useClientsDialogs() {
  const [selectedClient, setSelectedClient] = useState(null);
  const [editingClient, setEditingClient] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);

  const openCreate = () => setCreateOpen(true);
  const closeCreate = () => setCreateOpen(false);

  const openDetail = (client) => {
    setSelectedClient(client);
    setDetailOpen(true);
  };
  const closeDetail = () => {
    setDetailOpen(false);
    setSelectedClient(null);
  };

  const openEdit = (client) => {
    setEditingClient(client);
    setEditOpen(true);
    setDetailOpen(false);
  };
  const closeEdit = () => {
    setEditOpen(false);
    setEditingClient(null);
  };

  return {
    selectedClient,
    editingClient,
    createOpen,
    editOpen,
    detailOpen,
    openCreate,
    closeCreate,
    openDetail,
    closeDetail,
    openEdit,
    closeEdit,
    setEditingClient,
    setSelectedClient,
  };
}
